import FlexMarginGroup from 'app/components/layout/FlexMarginGroup';
import { useI18n } from 'app/components/localization';
import { ButtonA, ColorScheme } from 'app/components/presentation/buttons/ButtonClassNameA';
import { DeviceType, useDeviceManager, useDeviceManagerState } from 'app/containers/rtc/DeviceManagerContext';
import React, { FunctionComponent } from 'react';

interface IProps {
  type: DeviceType;
}

const WithSkip: FunctionComponent<IProps> = ({ type, children }) => {
  const deviceManager = useDeviceManager();
  const deviceManagerState = useDeviceManagerState();
  const { t } = useI18n();

  return (
    <FlexMarginGroup center wrap margin="1em">
      {!deviceManagerState[type].behaviorOptions.required && (
        <ButtonA onClick={deviceManager.skipVideo} colorScheme={ColorScheme.Secondary}>
          {t('rtc.device-setup.skip')}
        </ButtonA>
      )}
      {children}
    </FlexMarginGroup>
  );
};

export default WithSkip;
